import classNames from 'classnames';

import { Chevron, Link, ResponsiveText } from '@farmersdog/corgi';

import styles from './DigestHighlightsSlice.css';

interface BreedLinks {
  url: string;
  title: string;
}

function RelatedBreedLinks({ links }: RelatedBreedsProps) {
  return (
    <ul className={classNames(styles.leftColumn, styles.ul)}>
      {links.map(({ title, url }, i) => {
        return (
          <li className={styles.breedItem} key={`related-breed-${i}`}>
            <Link
              to={url}
              className={styles.breedLink}
              mode="dark"
              variant="secondary"
            >
              <ResponsiveText as="span" variant="body-2">
                {title}
              </ResponsiveText>
              <Chevron fill="carrot-2" />
            </Link>
          </li>
        );
      })}
    </ul>
  );
}

interface RelatedBreedsProps {
  links: BreedLinks[];
}

export function RelatedBreeds({ links }: RelatedBreedsProps) {
  return (
    <>
      <ResponsiveText
        className={classNames(styles.relatedHeading, styles.fullWidth)}
        as="h2"
        variant="heading-3"
        color="kale-3"
      >
        Related breeds
      </ResponsiveText>
      <RelatedBreedLinks links={links} />
    </>
  );
}
